<div class="checkout-page">

  <!-- ========================================= -->
  <!-- HEADER -->
  <!-- ========================================= -->

  <div class="checkout-header">

<div>
      <button
        type="button"
        class="back-button"
        (click)="goBackToCart()"
      >
        <span class="back-icon">←</span>

        {{ 'CHECKOUT.Back_to_Cart' | translate }}
      </button>
</div>

      <div class="header-title">

        <span class="title-accent">
          ✦
        </span>

        <div>

          <h1>
            {{ 'CHECKOUT.TITLE' | translate }}
          </h1>

          <p>
            {{ 'CHECKOUT.Complete_your_order' | translate }}
          </p>

        </div>

      </div>

    

  </div>


  <!-- ========================================= -->
  <!-- CONTENT -->
  <!-- ========================================= -->

  <div class="checkout-container">


    <!-- ======================================= -->
    <!-- CHECKOUT FORM -->
    <!-- ======================================= -->

    <form
      class="checkout-form"
      [formGroup]="checkoutForm"
   
      novalidate
    >


      <!-- ===================================== -->
      <!-- CUSTOMER INFORMATION -->
      <!-- ===================================== -->

      <section class="checkout-card">

        <div class="section-header">

          <div class="section-icon">
            01
          </div>

          <div>

            <h2>
              {{ 'CHECKOUT.CUSTOMER_INFORMATION' | translate }}
            </h2>

          </div>

        </div>


        <div class="form-grid">


          <!-- ================================= -->
          <!-- PHONE -->
          <!-- ================================= -->

          <div class="form-field full-width">

            <label for="phone">

              {{ 'CHECKOUT.PHONE' | translate }}

              <span>
                *
              </span>

            </label>


            <div class="phone-wrapper">

              <input
                id="phone"
                type="tel"
                formControlName="phone"
                placeholder="01XXXXXXXXX"
                autocomplete="tel"
                maxlength="11"
                [class.invalid]="isInvalid('phone')"
              />


              @if (isSearchingClient()) {

                <span class="searching">

                  {{ 'COMMON.Searching' | translate }}

                </span>

              }


              @if (clientFound()) {

                <span class="client-found">

                  ✓
                  {{ 'COMMON.client-found' | translate }}

                </span>

              }

            </div>


            @if (isInvalid('phone')) {

              <small>

                {{ 'CHECKOUT.INVALID_PHONE' | translate }}

              </small>

            }

          </div>


          <!-- ================================= -->
          <!-- FULL NAME -->
          <!-- ================================= -->

          <div class="form-field">

            <label for="fullName">

              {{ 'CHECKOUT.FULL_NAME' | translate }}

              <span>
                *
              </span>

            </label>


            <input
              id="fullName"
              type="text"
              formControlName="fullName"
              placeholder="Enter your full name"
              autocomplete="name"
              [class.invalid]="isInvalid('fullName')"
            />


            @if (isInvalid('fullName')) {

              <small>

                {{ 'CHECKOUT.INVALID_NAME' | translate }}

              </small>

            }

          </div>


          <!-- ================================= -->
          <!-- EMAIL -->
          <!-- ================================= -->

          <div class="form-field">

            <label for="email">

              {{ 'CHECKOUT.EMAIL' | translate }}

              <em>
                {{ 'CHECKOUT.OPTIONAL' | translate }}
              </em>

            </label>


            <input
              id="email"
              type="email"
              formControlName="email"
              placeholder="example@email.com"
              autocomplete="email"
              [class.invalid]="isInvalid('email')"
            />


            @if (isInvalid('email')) {

              <small>

                {{ 'CHECKOUT.INVALID_EMAIL' | translate }}

              </small>

            }

          </div>

        </div>

      </section>


      <!-- ===================================== -->
      <!-- DELIVERY INFORMATION -->
      <!-- ===================================== -->

      <section class="checkout-card">

        <div class="section-header">

          <div>

            <h2>
              {{ 'CHECKOUT.DELIVERY_INFORMATION' | translate }}
            </h2>

          </div>

        </div>


        <div class="form-grid">


          <!-- ================================= -->
          <!-- GOVERNORATE -->
          <!-- ================================= -->

          <div  class="form-field full-width">

            <label for="governorate">

              {{ isArabic ? 'المحافظة' : 'Governorate' }}

              <span>
                *
              </span>

            </label>

            <select
            
              id="governorate"
              formControlName="governorate"
              [class.invalid]="isInvalid('governorate')"
            >

              <!-- Placeholder -->

              <option
                value=""
                disabled
              >
                {{
                  isArabic
                    ? 'اختر المحافظة'
                    : 'Select governorate'
                }}
              </option>


              <!-- Governorates -->

              @for (
                governorate of governorates;
                track $index
              ) {

                <option
                  [value]="governorate.nameAr"
                >
                  {{ getGovernorateName(governorate) }}
                </option>

              }

            </select>


            @if (isInvalid('governorate')) {

              <small>

                {{
                  isArabic
                    ? 'برجاء اختيار المحافظة'
                    : 'Please select a governorate'
                }}

              </small>

            }
          </div>


          <!-- ================================= -->
          <!-- ADDRESS -->
          <!-- ================================= -->

          <div class="form-field full-width">

            <label for="address">

              {{ 'CHECKOUT.ADDRESS' | translate }}

              <span>
                *
              </span>

            </label>


            <textarea
              id="address"
              formControlName="address"
              rows="3"
              placeholder="Street name, building number, area..."
              autocomplete="street-address"
              [class.invalid]="isInvalid('address')"
            ></textarea>


            @if (isInvalid('address')) {

              <small>

                {{ 'CHECKOUT.INVALID_ADDRESS' | translate }}

              </small>

            }

          </div>

        </div>

      </section>


      <!-- ===================================== -->
      <!-- PAYMENT -->
      <!-- ===================================== -->

      <section class="checkout-card">

        <div class="section-header">

          <div class="section-icon">
            03
          </div>

          <div>

            <h2>
              {{ 'CHECKOUT.PAYMENT_METHOD' | translate }}
            </h2>

          </div>

        </div>


        <!-- Cash On Delivery -->

        <div class="payment-option selected">

          <div class="payment-radio">

            <div class="radio-dot"></div>

          </div>


          <div class="payment-content">

            <div class="payment-title">

              <span class="payment-icon">
                ₣
              </span>


              <div>

                <h3>
                  {{ 'CHECKOUT.CASH_ON_DELIVERY' | translate }}
                </h3>

                <p>
                  {{
                    'CHECKOUT.CASH_ON_DELIVERY_DESCRIPTION'
                    | translate
                  }}
                </p>

              </div>

            </div>

          </div>


          <div class="payment-check">

            ✓

          </div>

        </div>

      </section>

    </form>


    <!-- ======================================= -->
    <!-- ORDER SUMMARY -->
    <!-- ======================================= -->

    <aside class="order-summary">


      <!-- ===================================== -->
      <!-- SUMMARY HEADER -->
      <!-- ===================================== -->

      <div class="summary-header">

        <div>

          <span class="summary-label">

            {{ 'CHECKOUT.YOUR_ORDER' | translate }}

          </span>

          <h2>

            {{ 'CHECKOUT.Order_Summary' | translate }}

          </h2>

        </div>


        <span class="items-count">

          {{ totalItems }}

          {{
            totalItems === 1
              ? ('CART.ITEM' | translate)
              : ('CART.ITEMS' | translate)
          }}

        </span>

      </div>


      <!-- ===================================== -->
      <!-- EMPTY CART -->
      <!-- ===================================== -->
@if (cartLoading$ | async) {

  <div class="cart-loading">
   

    <span>
      {{ 'CHECKOUT.LOADING_CART' | translate }}
    </span>
  </div>

} @else if (cartItems.length === 0) {
     

        <div class="empty-cart">

          <span class="empty-cart-icon">
            🛒
          </span>

          <h3>
            {{ 'CART.EMPTY' | translate }}
          </h3>

          <p>
            {{ 'CART.EMPTY_MESSAGE' | translate }}
          </p>


          <button
            type="button"
            class="back-to-products"
            (click)="goBackToCart()"
          >
            {{ 'CHECKOUT.Back_to_Cart' | translate }}
          </button>

        </div>

      }


      <!-- ===================================== -->
      <!-- PRODUCTS -->
      <!-- ===================================== -->

      @if (cartItems.length > 0) {

        <div class="summary-products">

          @for (
            item of cartItems;
            track item.product.id 
          ) {

            <div class="summary-product">


              <!-- Product Image -->

              <div class="product-image">

               <img
  [src]="getImageUrl(item.product.imageUrl)"
  [alt]="getProductName(item)"
  (error)="onImageError($event)"
/>

              </div>


              <!-- Product Info -->

              <div class="product-info">

                <h3>
                  {{ getProductName(item) }}
                </h3>


                <p>

                  {{ 'CHECKOUT.Qty' | translate }}

                  : {{ item.quantity }}

                </p>


                <!-- Product Price -->

                <div class="product-pricing">

                  <div class="new-price">

                    {{ getDiscountedPrice(item) | number:'1.2-2' }}

                    {{ 'COMMON.EGP' | translate }}

                  </div>

                </div>

              </div>


              <!-- Product Subtotal -->

              <strong class="product-subtotal">

                {{ getItemSubtotal(item) | number:'1.2-2' }}

                {{ 'COMMON.EGP' | translate }}

              </strong>

            </div>

          }

        </div>

      }


      <!-- ===================================== -->
      <!-- TOTALS -->
      <!-- ===================================== -->

      @if (cartItems.length > 0) {

        <div class="summary-totals">


          <!-- Subtotal -->

          <div class="summary-row">

            <span>
              {{ 'CART.Subtotal' | translate }}
            </span>

            <strong>

              {{ subtotal }}

              {{ 'COMMON.EGP' | translate }}

            </strong>

          </div>

        </div>


        <!-- ================================= -->
        <!-- FINAL TOTAL -->
        <!-- ================================= -->

        <div class="summary-total">

          <span>
            {{ 'CART.TOTAL' | translate }}
          </span>

          <strong>

            {{ total }}

            {{ 'COMMON.EGP' | translate }}

          </strong>

        </div>


        <div>

          <small>
            {{ 'CHECKOUT.DELIVERY' | translate }}
          </small>

        </div>


        <!-- ================================= -->
        <!-- PLACE ORDER BUTTON -->
        <!-- ================================= -->

        <button
          type="button"
          class="place-order-button"
          [disabled]="
            isSubmitting() ||
            cartItems.length === 0
          "
          (click)="placeOrder()"
        >

          @if (isSubmitting()) {

            <span class="spinner"></span>

            <span>
              {{ 'COMMON.LOADING' | translate }}
            </span>

          }

          @else {

            <span>
              {{ 'CHECKOUT.PLACE_ORDER' | translate }}
            </span>

            <span class="button-arrow">
              →
            </span>

          }

        </button>


        <!-- ================================= -->
        <!-- SECURITY NOTE -->
        <!-- ================================= -->

        <div class="secure-note">

          <span>
            🔒
          </span>

          <span>
            {{ 'CHECKOUT.INFO' | translate }}
          </span>

        </div>

      }

    </aside>

  </div>

</div>
